import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/purchase-order/approval-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('prd/exports/purchase-order/approvals', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/approvals/${data.id}`, { data })
  }
}

export default ApprovalService
